<template>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="false"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
</template>
<script>
export default {
  name: "products",
props:{
  id: {
    default : null
  }
},
created() {
       this.itemLink =  `orders/${this.id}/statuses`;
      this.setLink = `orders/${this.id}/statuses`;
},
methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "status",
      fields: [
        
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_purchase",
      itemLink: "statuses",
      setLink: "statuses",
   columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          // sortBy:'id'
        },
       {
          key: "status",
          object: "title",
          title: "Установленный статус",
          disableLink:true
        },
       {
          key: "user",
          object: "name",
          title: "Кто установл статус",

        },
            {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
  
      ],
    };
  },
};
</script>
